export function make_jobid(){
	var jb='';
	$.ajax({
		url: "../php/create_jobid.php",
		method: "post",
		async:false,
		data: {
			"length": 6
		},
		success: function(r1, r2, r3){
			//console.log(r1);
			//obid=r1;
			//var json_object = $.parseJSON(r1);
			jb=r1;
			console.log(jb);
			//return jb;
			//$("#jobid").text(json_object["jobid"]);
		},
		error: function(r1){
			console.error("fail:", r1);
			jb=r1;
			//console.log(jb);
		}
	});
	return jb;
}